export default {"src":"/accounts/_next/static/media/location.b726406d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};